import React from "react";
import {
  BarChart2,
  ChevronUp,
  ChevronDown,
  ArrowUp,
  ArrowDown,
} from "lucide-react";
import {
  Bar,
  ResponsiveContainer,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  PieChart,
  Pie,
} from "recharts";

const MarketOverview = ({
  expandedSection,
  toggleSection,
  sectorData,
  sortedStocks,
}) => {
  return (
    <div className="insights-section">
      <div
        className="section-header clickable"
        onClick={() => toggleSection("overview")}
      >
        <h3>
          <BarChart2 size={20} />
          Market Overview
        </h3>
        <div className="section-toggle">
          {expandedSection === "overview" ? (
            <ChevronUp size={20} />
          ) : (
            <ChevronDown size={20} />
          )}
        </div>
      </div>

      {expandedSection === "overview" && (
        <div className="section-content">
          <div className="overview-grid">
            <div className="overview-card">
              <h4>Sector Performance</h4>
              <div className="chart-container">
                <ResponsiveContainer width="100%" height={300}>
                  <Bar
                    data={sectorData}
                    layout="vertical"
                    margin={{ top: 5, right: 30, left: 50, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" domain={["dataMin", "dataMax"]} />
                    <YAxis type="category" dataKey="name" width={80} />
                    <Tooltip
                      formatter={(value) => [
                        `${value.toFixed(2)}%`,
                        "Performance",
                      ]}
                    />
                    <Bar dataKey="performance" fill="var(--accent-color)">
                      {sectorData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={entry.performance > 0 ? "#10b981" : "#ef4444"}
                        />
                      ))}
                    </Bar>
                  </Bar>
                </ResponsiveContainer>
              </div>
            </div>

            <div className="overview-card">
              <h4>Value Opportunities by Sector</h4>
              <div className="chart-container">
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={sectorData}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="valueOpportunities"
                      nameKey="name"
                      label={({ name, percent }) =>
                        `${name}: ${(percent * 100).toFixed(0)}%`
                      }
                    >
                      {sectorData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip
                      formatter={(value) => [
                        `${value} stocks`,
                        "Value Opportunities",
                      ]}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          <div className="market-metrics">
            <div className="metric-card">
              <h4>Average Market Discount</h4>
              <div className="metric-value">
                <span>12.4%</span>
                <div className="trend up">
                  <ArrowUp size={16} />
                  <span>2.1%</span>
                </div>
              </div>
              <p>Below average discount to fair value</p>
            </div>

            <div className="metric-card">
              <h4>Market P/E Ratio</h4>
              <div className="metric-value">
                <span>19.2</span>
                <div className="trend down">
                  <ArrowDown size={16} />
                  <span>0.8</span>
                </div>
              </div>
              <p>Above historical average (16.9)</p>
            </div>

            <div className="metric-card">
              <h4>Interest Rate Impact</h4>
              <div className="metric-value">
                <span className="moderate">Moderate</span>
              </div>
              <p>Discount rates applying 4.5% risk-free</p>
            </div>

            <div className="metric-card">
              <h4>Value Opportunities</h4>
              <div className="metric-value">
                <span>{sortedStocks.length}</span>
                <div className="trend up">
                  <ArrowUp size={16} />
                  <span>5</span>
                </div>
              </div>
              <p>Matching your criteria</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MarketOverview;
